import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { ActivityEntry, dayAndTime } from '../riskView';
import { dayAndMonth } from '../surveyProcessView';
import process from '../WorkEnvironmentSurveyProcess.module.css';
import classes from '../WorkEnvironmentSurveyRisk.module.css';

export const ActivityCard = ({ entries }: { entries: ActivityEntry[] }): ReactElement => {
  const { t, i18n } = useTranslation();
  const texts = (entry: ActivityEntry): { title: string; meta: string | null } => {
    switch (entry.type) {
      case 'calculated':
        return { title: t('workEnvironmentRisk.activity.calculated'), meta: dayAndTime(entry.at, t, i18n.language) };
      case 'answered':
        return {
          title:
            entry.responses >= entry.expected
              ? t('workEnvironmentRisk.activity.answeredAll', { count: entry.responses })
              : t('workEnvironmentRisk.activity.answeredSome', entry),
          meta: entry.at
            ? t('workEnvironmentRisk.activity.lastResponse', { when: dayAndTime(entry.at, t, i18n.language) })
            : null,
        };
      case 'created':
        return { title: t('workEnvironmentRisk.activity.created'), meta: dayAndMonth(entry.at, i18n.language) };
      case 'event':
        return {
          title: t(`workEnvironmentRisk.activity.events.${entry.action}`),
          meta: [
            entry.email &&
              t('workEnvironmentRisk.activity.by', {
                email: entry.email,
                role: t(`workEnvironmentRisk.activity.roles.${entry.role}`),
              }),
            dayAndTime(entry.at, t, i18n.language),
          ]
            .filter(Boolean)
            .join(' · '),
        };
    }
  };
  return (
    <section aria-labelledby="activity-heading" className={`${process.card} ${process.sideCard}`}>
      <Heading level={2} data-size="xs" id="activity-heading">
        {t('workEnvironmentRisk.activity.title')}
      </Heading>
      <ol className={classes.log}>
        {entries.map((entry) => {
          const { title, meta } = texts(entry);
          return (
            <li key={`${entry.type}-${entry.at}`} className={classes.logEntry} data-type={entry.type}>
              <Paragraph data-size="sm">{title}</Paragraph>
              {meta && (
                <Paragraph data-size="xs" className={process.subtle}>
                  {meta}
                </Paragraph>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
};
